/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { mapModifiers } from 'libs/component';
import { Heading } from 'components/atoms/heading';
import Default from 'components/templates/default';
import { Section } from 'components/molecules/section';
import { OptionList } from 'components/molecules/option-list';
import { GETTING_HEAR_LIST,MRT_CONNECT_LIST,BUS_ROUTE_IMG_LIST,PARKING_LIST } from 'libs/constants';
import { Waypoint } from 'react-waypoint';
import { useTranslation } from 'react-i18next';
import { BUS_ROUTE_LIST } from 'libs/constants';
import { useEffect } from 'react';
import { Carousel } from 'components/organisms/carousel';
import { Image as AImage } from 'components/atoms/image';
import { motion } from 'framer-motion';
import { HowGettingHere } from 'components/organisms/how-getting-hear';

export interface MediaProps {
  currentTab?: number;
  onOptionSelected?: (tab: number) => void;
  onNewsClick?: (slug: string) => void;
}

export const BusRoute: React.FC<MediaProps> = ({ currentTab: defaultCurrentTab = 0,onOptionSelected}) => {
  const { i18n } = useTranslation();
  const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  
  const optionList = useMemo(() => {
    return BUS_ROUTE_LIST;
  }, []);
  useEffect(() => {
    setCurrentTab(defaultCurrentTab);
  }, [setCurrentTab, defaultCurrentTab, currentTab]);

  const handleOptionSelected = useCallback(
    (index: number) => {
      setCurrentTab(index);
      if (onOptionSelected) {
        onOptionSelected(index);
      }
    },
    [setCurrentTab, onOptionSelected]
  );
  
  const optionItemList = optionList.map(x => (x.label as any)[i18n.language]);
  
  const [ ,setCurrentTopicIndex] = useState(0);
  const policyRef = useRef(null);

  const GettingHearList = useMemo(() => {
    return GETTING_HEAR_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);
  const MrtConnectList = useMemo(() => {
    return MRT_CONNECT_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);
  const ParkingList = useMemo(() => {
    return PARKING_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const BusRouteMrtImgList: any[] = BUS_ROUTE_IMG_LIST;


  // const gettingHereRef = useRef(null);
  const [showGettingHereTab, setShowGettingHereTab] = useState(false);
  const gettingHereTabRef = useRef(null);
  const motionVariants = {
    gettingHereTab: {
      hidden: { opacity: 0, y: -20 },
      show: {
        opacity: showGettingHereTab ? 1 : 0,
        y: 0,
        transition: {
          delay: 0.25,
          duration: 0.5,
          ease: 'easeOut',
        },
      },
    },
    
  };

  const handleSectionEnter = useCallback((index: number) => {
    setCurrentTopicIndex(index);
  }, []);
  return (
    <div className={mapModifiers('t-privacy-policy')}>
      <Default>
        <article className="t-privacy-policy__content">
          <Section className="t-privacy-policy__heading">
            <Heading>乘车路线</Heading>
            <Section className="t-media__tabs">
              <OptionList
                currentIndex={currentTab}
                modifiers="horizontal"
                items={optionItemList}
                onSelected={handleOptionSelected}
              />
            </Section>
          </Section>

          
          {currentTab === 0 && (
            <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {GettingHearList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}
          {currentTab === 1 && (
             <div className='mrt'><strong>MRT换乘</strong></div>
          )}
          {currentTab === 1 && (
             <Carousel
               mode="gallery"
               modifiers="no-button"
             >
               {BusRouteMrtImgList.map((item: any, index: number) => (
                 <div key={index} className="t-home__gallery-item mrt_img" data-attribute="SRL">
                   <AImage
                     src={item.image as any}
                     srcSp={item.imageSp as any}
                     srcWebp={item.imageWebp as any}
                     srcWebpSp={item.imageWebpSp as any}
                     caption={item.caption}
                     align={item.align}
                     lazy={true}
                   />
                 </div>
               ))}
             </Carousel>
          //  </div>
           )}
          {currentTab === 1 && (
            <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {MrtConnectList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}
          
          {currentTab === 2 && (
            <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {ParkingList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}
          {currentTab === 3 && (
             <div className='mrt'><strong>交通方式</strong></div>
          )}
          {currentTab === 3 && (
            <Section className="t-home__getting-here">
            <div className="t-home__how-getting-here-tabs">
              <div className="t-home__getting-here-tabs-waypoint">
                <Waypoint onEnter={() => setShowGettingHereTab(true)} />
              </div>
              {/*<Waypoint onEnter={() => handleSectionScrollEnter('getting-here-tabs')} />*/}
              <motion.div
                ref={gettingHereTabRef}
                className="t-home__getting-here-tabs-content"
                variants={motionVariants.gettingHereTab}
                initial="hidden"
                animate="show"
              >
                <HowGettingHere />
              </motion.div>
            </div>
          </Section>
          )}
          
        </article>
      </Default>
    </div>
  );
};
